
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetCartsApiParameter } from "@insite/client-framework/Services/CartService";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetPunchoutIdentityApiParameter } from "@TKCCP/Services/PunchoutIdentityService";

type HandlerType = Handler<GetPunchoutIdentityApiParameter & UpdateSearchFieldsType>;

export const DispatchUpdateLoadParameter: HandlerType = props => {
    props.dispatch({
        type: "Pages/PunchoutIdentity/UpdateSearchFields" as any,
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateLoadParameter];

const updateSearchFields = createHandlerChainRunner(chain, "UpdateSearchFields");
export default updateSearchFields;
